/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, { CATEGORY_PORTAL } from "./core/BaseService";

export interface PwdWarningResponse {
    messageId?: string;
    message?: string;
}

class PwdWarningService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "pwdWarning");
    }

    // パスワード有効期限の警告メッセージ取得
    public async pwdWarning(resolved: (json: PwdWarningResponse) => void, rejected: (error: any) => void) {
        await super.getJSON((json: any) => {
            const response = json as PwdWarningResponse;
            resolved(response);
        }, rejected);
    }
}

export default PwdWarningService;
